import { Get } from "./api-base"
import { urls } from "./urls.constantes"

export const getSellers= (params) => {
    return Get(`${urls.SELLERS}`, params);
}

export const getUserById = (Id) => {
    return Get(`${urls.SELLERS}/${Id}`)
}